// extracted by mini-css-extract-plugin
module.exports = {"name":"\"less\"","size":"var(--size, 50px)","fontColor":"var(--fontColor, #5bb3e5)"};